(function () {
    'use strict';
    var  gettext = angular.identity;

    angular
        .module('app.login')
        .constant('login_resources', {
            resetPendingStatusFailed: gettext('Failed to reset pending status.'),
            unknownLoginError: gettext('An unknown login error occurred.'),
            accountDetailRequestFailed: gettext('Failed to retrieve account details.'),
            saveAccountDetailsFailed: gettext('Failed to save account details.'),
            saveEmailFailed: gettext('Failed to save email address.')
        });
})();